export const API_URL = process.env.REACT_APP_API_URL;
export const FAST_API_URL = process.env.REACT_APP_FAST_API_URL;